import type { SectionsExplanationTextComponent } from '@twisto/api-cms'

import { APRBlock } from '../../molecules'

import * as styles from './explanation-text.styles'

export const ExplanationText = ({ text }: SectionsExplanationTextComponent) => (
  <section css={styles.section}>{text && <APRBlock {...text} />}</section>
)
